// extracted by mini-css-extract-plugin
export default {"title_div":"title_title_div__4tlAP","title_content":"title_title_content__DTlu+","back_img":"title_back_img__xTMlY"};